export default __webpack_public_path__ + "static/overlay-wheel-9a8325fcf7bc1308b0c95f793642a2f2.png";